export default function Gallery() {
  // Creamos un array [1, 2, ..., 10]
  const images = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-semibold">Galería</h2>

        <div className="mt-6 grid md:grid-cols-2 gap-4">
          {images.map((num) => (
            <div
              key={num}
              className="aspect-[4/3] rounded-xl overflow-hidden"
            >
              <img
                src={`/galeria/${num}.jpg`}
                alt={`Imagen ${num}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
